<template>
  <div class="order-fee-box" v-if="detail.orderSource === 1">
    <div class="title-box">
      <el-image :src="cheImage" class="title-label"></el-image>
      订单收费明细信息
    </div>
    <div>
      <div class="title-box">
        <span>
          <span>收款类型：</span>
          <span class="price color526bec" v-if="detail.paymentType === 1">现付</span>
          <span class="price color526bec" v-if="detail.paymentType === 2">到付</span>
          <span class="price color526bec" v-if="detail.paymentType === 3">回单付</span>
        </span>
        <span style="margin-left: 100px">
          <span>是否代收：</span>
          <span class="price color526bec">{{ detail.agency ?'是':'否'}}</span>
        </span>
        <span style="margin-left: 100px" v-if="detail.agency">
          <span>代收金额：</span>
          <span class="price color526bec">{{ numberToThousand(detail.agencyFee) }}元</span>
        </span>
        <span style="margin-left: 100px">
          <span>第三方报价：</span>
          <span class="price color526bec" >{{ numberToThousand(detail.quotes) }}元</span>
        </span>
      </div>
      <div class="title-box">
        客户支付价格：
        <span class="price color526bec" style="margin-right: 50px">{{ numberToThousand(detail.payableFee) }}元</span>
        实际支付价格：
        <span class="price color526bec">{{ numberToThousand(detail.actualPayableFee) }}元</span>
      </div>
      <el-row class="price-des-box">
        <el-col :span="12" class="label-val">
          <span class="label">初始运单价格：</span>
          <span class="value">￥{{ numberToThousand(detail.sourceFee) }}</span>
        </el-col>
        <el-col :span="12" class="label-val">
          <span class="label">优惠/加价后价格：</span>
          <span class="value">￥{{ numberToThousand(detail.fee) }}</span>
        </el-col>
        <el-col :span="12" class="label-val">
          <span class="label">代理商运营费：</span>
          <span class="value">￥{{ numberToThousand(detail.agentFee) }}</span>
        </el-col>
        <el-col :span="12" class="label-val">
          <span class="label">发票价格：</span>
          <span class="value">￥{{ numberToThousand(detail.invoiceFee) }}</span>
        </el-col>
      </el-row>
    </div>
    <div>
      <div class="title-box">
        司机运费：
        <span class="price color526bec">{{ numberToThousand(detail.driverFee) }}元</span>
      </div>
      <el-row class="price-des-box">
        <el-col :span="12" class="label-val">
          <span class="label">初始运单价格：</span>
          <span class="value">￥{{ numberToThousand(detail.sourceFee) }}</span>
        </el-col>
        <el-col :span="12" class="label-val">
          <span class="label">优惠/加价后价格：</span>
          <span class="value">￥{{ numberToThousand(detail.fee) }}</span>
        </el-col>
        <el-col :span="12" class="label-val">
          <span class="label">服务商运营费：</span>
          <span class="value">￥{{ numberToThousand(detail.platformCommissionFee) }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

import {numberToThousand} from "@/utils/tool"
export default {
  name: "OrderFeeTemplate",
  props: {
    detail: {
      type: Object,
      default: () =>{
        return {}
      }
    }
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
    }
  },
  methods: {
    numberToThousand
  }
}
</script>

<style scoped lang="scss">
.order-fee-box {
  width: 100%;
  .title-box {
    padding: 0.2rem 0 0;
  }
  .price-des-box{
    background-color: #F7FBFF;
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    border-radius: 5px;
    margin-top: 0.1rem;
  }
  .price{
    font-size: 0.16rem;
  }
  .label-val {
    margin-bottom: 0.16rem;
    .label{
      width: 1.2rem;
      text-align: right;
    }
  }
  .label-val{
    .label{
      color: #000000;
    }
    .value{
      color: #0a65f0;
      font-size: 0.16rem;
    }
  }
}
</style>
